import { render } from "./OuterTopPage.vue?vue&type=template&id=2bb3c46e&scoped=true&ts=true"
import script from "./OuterTopPage.vue?vue&type=script&lang=ts"
export * from "./OuterTopPage.vue?vue&type=script&lang=ts"

import "./OuterTopPage.vue?vue&type=style&index=0&id=2bb3c46e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb3c46e"]])

export default __exports__